<template>
	<div class="dropProvice flex-column">
		<div class="header itemCenter space-between">
			<i class="fa fa-angle-left" @click="closePick" ></i>
			<span>选择列表</span>
		</div>

		<div class="lc_cityTab flex-column-1 flex-column">
			<ul class="cityTab_list flex">
				<li class="active">选择列表</li>
			</ul>
			<ul class="lc_proList flex fwrap">
				<li v-for="(item,idx) in chooseList" class="flex itemCenter fCenter" @click="select(item,idx)" :class="{'active': chooseIndex === idx}">{{item[pickParmas.sonkeyValue]}}</li>
			</ul>
		</div>

	</div>
</template>

<script>
import { Header } from 'mint-ui';

export default {
	props:["pickParmas"],
	data () {
		return{
			proviceTab: null,
			chooseIndex: null,
			chooseList:[]
		}
	},
	methods : {
		closePick () {
			this.$emit("closeCommonPick")
		},
		/*根据选择数值*/
		select(item,idx) {
			this.chooseIndex = idx
			this.$emit("commonPick",item)
		},
		getData () {
			this.$get(this.pickParmas.url,
				this.pickParmas,
				data => {
					this.chooseList = data
				},
		        error => {
		        	
		        }
	      	)
		}
	},
	mounted () {
		this.getData ()
	}
}
</script>


<style lang="scss" scoped>
	.dropProvice {
	    position: fixed;
	    width: 100%;
	    height: 100%;
	    top: 0;
	    left: 0;
	    z-index: 100;
	    background-color: #FFFFFF;
	    font-size:14px;
    .header {
        width: 100%;
        height: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
        padding-left: 0.47rem;
        box-sizing: border-box;
        position:relative;
        span {
            font-size: 0.56rem;
            color: #333333;
        }
        .iconfont {
            font-size: 0.62rem;
            color: #666666;
        }
        .fa-angle-left{
	    	font-size:0.8rem;
	    	position: absolute;
	    	left:0.4rem;
	    	top:0.3rem;
	    }
    }
    .lc_cityTab {
        .cityTab_list {
        	width:100%;
        	height:1.25rem;
	        border-bottom: 0.06rem solid #05BC6A;
	        padding-top:0.2rem;
	        margin-bottom:0;
	        li {
	            width: 2.6rem;
	            height: 1.0rem;
	            text-align: center;
	            line-height: 1.0rem;
	            font-size: 14px;
	            float:left;
	            background: #E6F9F1;
	            color: #838985;
	            border-radius: 0.12rem 0.12rem 0 0;
	            margin-left: 0.28rem
	        }
	        .active {
	            color: #FFFFFF;
	            background: #4BB895;
	        }
        }
        .lc_proList {
        	display: flex;
        	flex-wrap:wrap;
            li {
            	display: flex;
            	justify-content:center;
            	align-items:center;
	            width: 2.3rem;
	    		padding: 0.2rem 0.2rem;
	            line-height: 0.8rem;
	            text-align: center;
	            font-size: 14px;
	            color: #070707;
	            background: #F7F8F7;
	            border-radius: 0.12rem;
	            margin: 0.1rem;
            }
            .active {
	            color: #FFFFFF;
	            background: #4BB895;
            }
        }
    }
}
</style>